"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SPACE_BETWEEN_BUTTONS = 2;
const SiteToolbar = _ref => {
  let {
    items,
    ...props
  } = _ref;
  const spacingUnits = SPACE_BETWEEN_BUTTONS / 2;
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Toolbar, props, _lodash.default.map(items, _ref2 => {
    let {
      label,
      variant,
      sx,
      ...itemProps
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_material.Button, _extends({
      key: label,
      variant: "text",
      color: "inherit",
      sx: _lodash.default.merge({}, sx, {
        mx: spacingUnits
      })
    }, itemProps), label);
  })));
};
SiteToolbar.defaultProps = {};
SiteToolbar.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired
  })),
  ..._material.Toolbar.propTypes
};
var _default = exports.default = SiteToolbar;